import { render, staticRenderFns } from "./nameTabs.vue?vue&type=template&id=1f76750c&"
import script from "./nameTabs.vue?vue&type=script&lang=js&"
export * from "./nameTabs.vue?vue&type=script&lang=js&"
import style0 from "./nameTabs.vue?vue&type=style&index=0&id=1f76750c&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f76750c')) {
      api.createRecord('1f76750c', component.options)
    } else {
      api.reload('1f76750c', component.options)
    }
    module.hot.accept("./nameTabs.vue?vue&type=template&id=1f76750c&", function () {
      api.rerender('1f76750c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/nameTabs.vue"
export default component.exports